<template>
  <div>
    <mf-card-container :title="title" :hide-card-shadow="hideCardShadow">
      <mf-info-card v-if="isIndustryCampaign && ungroupedProducts.length > 0" variant="success" :v-html="industryRebateWarning" icon="payments" />
      <dynamic-pricing-percentage-discount-table
        :ref="offerSalesType"
        class="mt-4"
        type="ungrouped"
        :campaign="campaign"
        :products="ungroupedProducts"
        :validations="$v"
        :headers="headers"
        :helpers="helpers"
        :repeated-skus="repeatedSkus"
        :search="search"
        :is-disabled-in-rules="isDisabledInRules"
        :is-industry-campaign="isIndustryCampaign"
        :tooltip-message="tooltipMessage"
        :disabled="disabled"
        @remove-item="removeItem"
      />
    </mf-card-container>

    <div v-if="groupedProducts && groupedProducts.length > 0">
      <h2 class="ma-0 pb-0 pt-8">Grupos na oferta</h2>
      <p class="offers-subtitle pt-3">
        {{ groupDescription }}
      </p>

      <group-card
        v-for="(group, index) in groupedProducts"
        :key="group._id"
        offer-sales-type="dynamic_pricing_percentage_offer_sales"
        :group="group"
        :headers="headers"
        :helpers="helpers"
        :repeated-skus="repeatedSkus"
        :validations="$v"
        :group-index="index"
        :search="search"
        :is-disabled-in-rules="isDisabledInRules"
        :is-industry-campaign="isIndustryCampaign"
        :tooltip-message="tooltipMessage"
        :disabled="disabled"
        :campaign="campaign"
        @remove-item="removeItem"
        @remove-group="removeGroup(group._id)"
        @change-group-exhibition="changeGroupExhibition($event, group._id)"
      />
    </div>
  </div>
</template>

<script>
import GroupCard from '../GroupCard.vue'
import DynamicPricingPercentageDiscountTable from './DynamicPricingPercentageDiscountTable.vue'

import { required, requiredIf } from 'vuelidate/lib/validators'
import { notOnlySpace } from '@/helpers/validators.js'
import {
  eansValidation,
  percentageDiscountValidation,
  minMaxPerClientValidation,
  distributionLimitValidation,
} from '@/modules/campanhas/gestao-ofertas-v2/helpers/validators.js'

import { offerSalesTablesContainer } from '../../../mixins/offer-sales-tables-container'
import intelligentDistributionMixin from '../../../mixins/intelligent-distribution'
export default {
  name: 'DynamicPricingPercentageDiscount',
  components: {
    GroupCard,
    DynamicPricingPercentageDiscountTable,
  },
  mixins: [offerSalesTablesContainer, intelligentDistributionMixin],
  computed: {
    offerSalesType() {
      return 'dynamic_pricing_percentage_offer_sales'
    },
    title() {
      return this.ungroupedProducts.length === 1
        ? '1 produto desagrupado com desconto percentual por loja'
        : `${this.ungroupedProducts.length} produtos desagrupados com desconto percentual por loja`
    },
    headers() {
      let headers = [
        {
          text: '',
          value: 'expandAction',
          width: '2%',
          sortable: false,
        },
        {
          text: '',
          value: 'image',
          width: '5%',
          sortable: false,
        },
        {
          text: 'SKU',
          value: 'sku',
          width: '12%',
          sortable: false,
        },
        {
          text: 'EAN',
          value: 'ean',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Nome',
          value: 'name',
          width: '30%',
          sortable: false,
        },
        {
          text: 'Desconto',
          value: 'percentage_discount',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Mín. CPF',
          value: 'minimum_per_client',
          width: '10.5%',
          sortable: false,
        },
        {
          text: 'Máx. CPF',
          value: 'maximum_per_client',
          width: '10.5%',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
          width: '',
        },
        {
          text: '',
          value: 'action',
          sortable: false,
        },
        {
          text: '',
          value: 'units_with_price_1',
          sortable: false,
        },
      ]

      if (this.isIntelligentDistributionEnabled) {
        const statusIndex = headers.findIndex((header) => header.value === 'status')
        if (statusIndex >= 0) {
          headers.splice(statusIndex, 0, {
            text: 'Limite de ofertas',
            value: 'distribution_limit',
            width: '15%',
            sortable: false,
          })
        }
      }

      return headers
    },
  },
  validations() {
    const fields = {
      required: requiredIf(function () {
        return this.allInputsRequired
      }),

      $each: {
        sku: requiredIf(function (group) {
          return !group.products
        }),
        name: { required, notOnlySpace },
        eans: { eansValidation },
        minMaxPerClientValidation: { minMaxPerClientValidation },
        percentage_discount: { percentageDiscountValidation },
        distribution_limit: { distributionLimitValidation: distributionLimitValidation(this) },
        products: {
          $each: {
            eans: {
              eansValidation,
            },
            name: { required, notOnlySpace },
          },
        },
      },
    }
    return {
      ...(this.ungroupedProducts.length > 0
        ? {
            ungroupedProducts: { ...fields },
          }
        : {}),

      ...(this.groupedProducts.length > 0
        ? {
            groupedProducts: { ...fields },
          }
        : {}),
    }
  },
}
</script>

<style lang="scss" scoped>
.offers-subtitle {
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0.4px;
  color: $cinza-0;
  max-width: 930px;
}
</style>
